import React from 'react';
import { Translate } from 'react-redux-i18n';
import get from 'lodash.get';
import { ViewTable } from '../../components/layouts/viewTable';
import { ViewSectionRow } from '../../components/layouts/viewSectionRow';
import { UrlWithCopy } from '../../components/common/UrlWithCopy';
import { PageEntityModel, ExtraDetailRow } from './types';
import { formatDateTime } from '../../utils/time/formatDateTime';
import { formatTimeElapsed } from '../../utils/time/formatTimeElapsed';

interface PageEntityDetailsProps {
  entity: PageEntityModel;
  isShowEmptyFields: boolean;
  translationBase: string; // e.g. fundraiser.fundraiser-view
  extraRows?: ExtraDetailRow[];
  includeVisibility?: boolean; // some entities might not have visibility flag
}

export const PageEntityDetails: React.FC<PageEntityDetailsProps> = ({
  entity,
  isShowEmptyFields,
  translationBase,
  extraRows = [],
  includeVisibility = true
}) => {
  const urlFull = get(entity, 'urlFull');
  const createdAt = get(entity, 'createdAtLocal');
  const updatedAt = get(entity, 'lastUpdatedAtLocal');

  return (
    <div className="entity-details">
      <ViewTable title={<Translate value={`${translationBase}.details.title`} />}>
        <ViewSectionRow title={`${translationBase}.details.url`} data={urlFull ? <UrlWithCopy url={urlFull} /> : null} isShowEmptyFields={isShowEmptyFields} />
        <ViewSectionRow 
          title={`${translationBase}.details.created`} 
          data={createdAt ? `${formatDateTime(createdAt)} - ${formatTimeElapsed(createdAt)}` : ''} 
          isShowEmptyFields={isShowEmptyFields} 
        />
        <ViewSectionRow 
          title={`${translationBase}.details.modified`} 
          data={updatedAt ? `${formatDateTime(updatedAt)} - ${formatTimeElapsed(updatedAt)}` : ''} 
          isShowEmptyFields={isShowEmptyFields} 
        />
        {extraRows.map((r, idx) => (
          <ViewSectionRow key={idx} title={r.title} data={r.value} isShowEmptyFields={isShowEmptyFields || r.showEmpty} />
        ))}
      </ViewTable>
    </div>
  );
};
